export default {
  methods: {
    /**
    * Handle Back
    * @desc Extends default router back functionality
    * @param {string} fallback - The fallback path if there is no history to use with $router.back(). This is usually the case if the page was visited directly or from another site
    **/
    handleBack (fallback) {
      if (!this.$store.state.route.from.name) {
        this.$router.push(fallback);
      } else {
        this.$router.back();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/mixins/HandleBack.js